import React from 'react';
import { Plus } from 'lucide-react';
import {
  Button,
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@roger/ui-components';

interface AddWoundButtonProps {
  onClick: () => void;
  disabled?: boolean;
}

const AddWoundButton: React.FC<AddWoundButtonProps> = ({
  onClick,
  disabled = false,
}) => {
  const button = (
    <Button size='sm' onClick={onClick} disabled={disabled}>
      <Plus className='h-4 w-4 mr-1' />
      Add Wound
    </Button>
  );

  if (disabled) {
    return (
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            {/* Wrap in span so the tooltip still fires on a disabled button */}
            <span className='inline-flex'>{button}</span>
          </TooltipTrigger>
          <TooltipContent>Wounds can only be added from a visit</TooltipContent>
        </Tooltip>
      </TooltipProvider>
    );
  }

  return button;
};

export default AddWoundButton;
